import React, { useContext, useState, useEffect } from 'react';
import { useIntercom } from 'react-use-intercom';
import { useNavigate } from 'react-router-dom-v5-compat';
import { AuthContext } from '../../../App';
import ROUTES from '../../../routes';
import SpinnerLoadingPage from '../../../shared/components/loading/spinner-loading-page';
import ProseMirrorComponentV2 from '../../../shared/components/prosemirror';
import { ONBOARDING_FIRST_MEETING_PAGE, ERROR_EVENT, CREATE_MEETING_ERROR_EVENT } from '../../../utils/analytics/enums';
import { logOnboardingEvent, logPageEvent } from '../../../utils/analytics/eventLogger';
import { MEETING_SECTION } from '../../../utils/enums';
import { getFirepadPathV3 } from '../../../utils/firebase';
import { createEventInGoogleCalendarAndMeetingInDatabase, insertFirstMeetingNotes } from './utils/functions';

const FirstMeeting = () => {
  const authState = useContext(AuthContext);
  const navigate = useNavigate();
  const { trackEvent } = useIntercom();

  const [firstMeetingId, setFirstMeetingId] = useState('');
  const [isNotesInserted, setIsNotesInserted] = useState(false);
  const [proseMirrorEditorView, setProseMirrorEditorView] = useState<any>({ page: '', editorView: '' });
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    createEventInGoogleCalendarAndMeetingInDatabase(authState, setFirstMeetingId, setIsError);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (!proseMirrorEditorView.editorView) return;
      insertFirstMeetingNotes(proseMirrorEditorView.editorView, setIsNotesInserted, setIsError);
    }, 2000); // Timeout just in case it takes a bit of time to resolve the editor view
  }, [proseMirrorEditorView]);

  useEffect(() => {
    if (!isNotesInserted) return;

    logPageEvent(authState.userId, trackEvent, ONBOARDING_FIRST_MEETING_PAGE);
    navigate(`/meeting/${firstMeetingId}`);
  }, [isNotesInserted]);

  useEffect(() => {
    if (isError) {
      logOnboardingEvent(
        authState.userId, trackEvent,
        ONBOARDING_FIRST_MEETING_PAGE, ERROR_EVENT,
        CREATE_MEETING_ERROR_EVENT,
      );
      navigate(ROUTES.dashboardPath);
    }
  }, [isError]);

  if (firstMeetingId.length !== 0) {
    return (
      <ProseMirrorComponentV2
        path={getFirepadPathV3(MEETING_SECTION.SHARED_NOTES, firstMeetingId, 'prosemirror', authState.userId)}
        meetingSection={MEETING_SECTION.SHARED_NOTES}
        setProseMirrorEditorView={setProseMirrorEditorView}
        displayNotes={false}
      />
    );
  }

  return (
    <SpinnerLoadingPage />
  );
};

export default FirstMeeting;
